import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToggleLabel, ToggleSwitch, ToggleSwitchCheckbox, ToggleWrapper } from './Toggle.styles';
export const Toggle = ({ ariaLabel, isChecked = false, isDisabled = false, label, labelSize = 'S', name, onClick, testId, value })=>/*#__PURE__*/ _jsxs(ToggleWrapper, {
        $isDisabled: isDisabled,
        "aria-label": ariaLabel,
        children: [
            /*#__PURE__*/ _jsx(ToggleSwitchCheckbox, {
                checked: isChecked,
                "data-checked": isChecked,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onChange: onClick,
                value: value
            }),
            /*#__PURE__*/ _jsx(ToggleSwitch, {
                $isChecked: isChecked,
                $isDisabled: isDisabled
            }),
            /*#__PURE__*/ _jsx(ToggleLabel, {
                $isDisabled: isDisabled,
                isBold: true,
                size: labelSize,
                children: label
            })
        ]
    });

//# sourceMappingURL=Toggle.js.map